
import { defineComponent, ref, inject, watch } from "vue";
import { Field, ErrorMessage } from "vee-validate";

export default defineComponent({
  name: "ProfessionalSummary",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const formData = ref<Record<string, unknown>>(props.formDataTemp);
    const telephone = ref<string>("");
    const currencyCode = ref<string>("");
    const geoFocusCountryCode = ref<string>("");
    const website = ref<string>("");
    const business = inject("business");
    watch(() => props.formDataTemp, (value) => {
      formData.value = {...value}
      syncData(value);
    });
    const limitInput = (event) => {
      if (event.target.value.length > 11) {
        event.preventDefault();
      }
      if (event.charCode < 48 || event.charCode > 57) {
        event.preventDefault();
      }
    };
    const formatTelephone = (e) => {
      if (e.target.value.charCodeAt(0) != 48 && e.target.value) {
        telephone.value = "0" + telephone.value;
      }
      if (e.target.value.length == 6) {
        telephone.value =
          (telephone.value as string).substr(0, 5) +
          " " +
          (telephone.value as string).substr(5);
      }
    };
    const syncData = (value) => {
      telephone.value = value.telephone;
      currencyCode.value = value.currencyCode;
      geoFocusCountryCode.value = value.geoFocusCountryCode;
      website.value = value.website;
    };
    const fieldChanged = (event) => {
      formData.value[event.target.name] = event.target.value;
      emit("form-data", formData.value);
    };
    return {
      limitInput,
      formatTelephone,
      formData,
      fieldChanged,
      telephone,
      website,
      currencyCode,
      geoFocusCountryCode,
    };
  },
});
